import { InjectionToken } from '@angular/core';

export interface TenantRuntimeConfig {
  readonly slug: string;
  readonly displayName: string;
}

export const TENANT_RUNTIME_CONFIG = new InjectionToken<TenantRuntimeConfig>('TENANT_RUNTIME_CONFIG');

export function normalizeTenantSlug(value: unknown): string {
  return String(value || '').trim().toLowerCase();
}

export function tenantConfigMatchesRuntime(
  actualSlug: unknown,
  runtime: TenantRuntimeConfig,
): boolean {
  return normalizeTenantSlug(actualSlug) === normalizeTenantSlug(runtime.slug);
}
